import { downloadSecure } from "../../assets/images/svg/DownloadApp";
import { loanfrontHorizontalIcon } from "../../assets/images/svg/Branding";
import Button from "../../components/Button";
import Download from "../../components/Download/Download";
import "./DownloadApp.scss";

const DownloadApp = () => {
  return (
    <div className="downloadAppMainContainer">
      <img src={loanfrontHorizontalIcon} className="loanfrontLogo" alt="" />
      <div className="subCard">
        <div className="profileCreatedCard">
          <img src={downloadSecure} alt="" />
          <p>
            Your profile is <span>approved!</span>
          </p>
          <span className="approvedCard">You are eligible to take a loan</span>
        </div>
      </div>
      <Download className="downloadClass" noText={true} />
    </div>
  );
};

export default DownloadApp;
